import React from 'react';
import styles from '../emergencyAlert.module.css';
import { RadioButton } from 'primereact/radiobutton';

const TemplateCard = React.memo(({
    template,
    isSelected,
    onSelect,
    selectedBackgroundColor,
    selectedTextColor
}) => {

    const handleChange = React.useCallback((e) => {
        e.stopPropagation();
        onSelect(template.templateId);
    }, [template.templateId, onSelect]);

    const handlePreviewClick = React.useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        onSelect(template.templateId);
    }, [template.templateId, onSelect]);

    // Apply colors to template preview similar to the preview dialog, but only if this template is selected
    const getModifiedTemplateInfo = React.useMemo(() => {
        // Only apply colors if this template is selected and colors are chosen
        if (!isSelected || (!selectedBackgroundColor && !selectedTextColor)) {
            return template.templateInfo;
        }

        const bgColor = selectedBackgroundColor?.code || '#ffffff';
        const textColor = selectedTextColor?.code || '#000000';

        // Predefined style replacements for better performance
        const styleReplacements = [
            { className: 'alert-container', style: `background-color: ${bgColor}; color: ${textColor};`, },
            { className: 'alert-label', style: `color: ${textColor};` },
        ];

        // Apply all style replacements efficiently, appending to existing styles
        let modifiedTemplateInfo = template.templateInfo;
        styleReplacements.forEach(({ className, style }) => {
            // Check if element already has a style attribute
            const styleRegex = new RegExp(`class="${className}"(\\s+style="([^"]*)")?`, 'g');
            modifiedTemplateInfo = modifiedTemplateInfo.replace(styleRegex, (match, existingStyleAttr, existingStyles) => {
                if (existingStyles) {
                    // Append new styles to existing ones
                    const combinedStyles = existingStyles + '; ' + style;
                    return `class="${className}" style="${combinedStyles}"`;
                } else {
                    // Add new style attribute
                    return `class="${className}" style="${style}"`;
                }
            });
        });

        return modifiedTemplateInfo;
    }, [template.templateInfo, selectedBackgroundColor, selectedTextColor, isSelected]);

    return (
        <div
            className={`${styles.template} ${
                isSelected ? styles.template_selected : ''
            }`}
        >
            <div className={styles.template_preview} onClick={handlePreviewClick}>
                <div className={styles.template_checkbox}>
                    <RadioButton
                        checked={isSelected}
                        onChange={handleChange}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
                <div
                    className={styles.template_preview_content}
                    dangerouslySetInnerHTML={{
                        __html: getModifiedTemplateInfo,
                    }}
                />
            </div>
        </div>
    );
});

TemplateCard.displayName = 'TemplateCard';

export default TemplateCard;
